import tokens from '@kluein/design-tokens';
import { Box, Button, getSizeFromTheme, Text } from '@kluein/klue-ui';
import { useTranslation } from 'react-i18next';

import TEST_IDS from 'test-ids';
import TRACKING_IDS from 'tracking-ids';

import type { RivalGroupType } from 'api/api.types';

export type DropContentProps = {
  group: number | undefined;
  onSelectGroup: (group: number | undefined) => void;
  rivalGroups: RivalGroupType[];
};

export const COMPANY_DEFAULT_ID = -2;

export const DROP_WIDTH = `${
  getSizeFromTheme('medium') + getSizeFromTheme('xxsmall')
}px`;

function GroupDropContent(props: DropContentProps) {
  const { t } = useTranslation();
  const { group: activeGroup, onSelectGroup, rivalGroups } = props;

  const options = [
    { id: -1, name: t('Dashboard:filters.allGroups') },
    { id: 0, name: t('Dashboard:filters.allCompanies') },
    { key: 'divider-top' },
  ]
    .concat(rivalGroups.filter(({ id }) => id > 0))
    .concat([
      { key: 'divider-bottom' },
      {
        id: COMPANY_DEFAULT_ID,
        name: t('Dashboard:filters.companyDefault'),
      },
    ]);

  const onGroupSelection = (id: number | undefined) => onSelectGroup(id);

  return (
    <Box
      gap="hair"
      pad={{
        horizontal: 'medium',
        top: 'large',
        bottom: 'medium',
      }}
      width={DROP_WIDTH}
      data-test-id={TEST_IDS.dashboard.filterDrops.group.dropContent}
    >
      <Text size="small" color={tokens.color.neutral.darkgrey.main}>
        {t('Dashboard:filterGroups')}
      </Text>
      {options.map((group) => {
        if (group?.key?.startsWith('divider')) {
          return (
            <Box
              key={group.key}
              flex={{ grow: 1 }}
              background={tokens.color.neutral.lightgrey.main}
              height="hair"
              margin={{ vertical: 'xxsmall' }}
            />
          );
        }

        return (
          <Button
            active={group.id === activeGroup}
            fill
            variant="flat-menu"
            onClick={() => onGroupSelection(group.id)}
            key={group.name}
            label={group.name}
            title={group.name}
            data-tracking-id={`${TRACKING_IDS.dashboard.filters.groupDrop.itemPrefix}-${group.id}`}
          />
        );
      })}
    </Box>
  );
}

export default GroupDropContent;
